import { render, staticRenderFns } from "./BaseFormSchedule.vue?vue&type=template&id=3b5af57f&"
import script from "./BaseFormSchedule.vue?vue&type=script&lang=js&"
export * from "./BaseFormSchedule.vue?vue&type=script&lang=js&"
import style0 from "./BaseFormSchedule.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports